/* eslint-disable import/no-named-as-default-member */
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import { LangID, langId } from '@/constants/lang';
import { localStorageKeys } from '@/constants/localStorage.ts';
import { isMock } from '@/utils/mode.ts';

const langs = Object.keys(langId);

const loadLocale = async (
  value: LangID,
  getLocale: () => Promise<Record<string, string> | null>,
) => {
  if (i18n.store.data[value]) return;

  const res = await getLocale();
  if (!res) return;

  i18n.addResourceBundle(value, 'translation', res);
};

export const changeLanguage = async (
  value: LangID,
  getLocale: () => Promise<Record<string, string> | null>,
) => {
  try {
    await loadLocale(value, getLocale);

    i18n.changeLanguage(value);

    document.documentElement.lang = i18n.language;
  } catch (e) {
    const enLang = await import('./langs/en/en.ts');
    i18n.addResourceBundle(langId.en, 'translation', enLang.lang);

    throw e;
  }
};

export async function init() {
  // взять язык из квери
  const detect =
    'Telegram.WebApp.initDataUnsafe?.user?.language_code' as LangID;
  const savedLang = localStorage.getItem(localStorageKeys.lang) as LangID;
  let lang: LangID = langId.en;

  if (langs.includes(detect)) {
    lang = detect;
  }

  if (savedLang && langs.includes(savedLang)) {
    lang = savedLang;
  }

  i18n.use(initReactI18next).init({
    resources: {},
    fallbackLng: lang,
    lng: lang,
    returnEmptyString: false,
    interpolation: {
      escapeValue: false,
    },
  });

  if (isMock) {
    const enLang = await import('./langs/en/en.ts');
    i18n.addResourceBundle(langId.en, 'translation', enLang.lang);
  }
}

export default i18n;
